import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import SEO from '@/components/SEO';
import { site } from '@/data/content';

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page not found"
        description="The page you are looking for does not exist."
        path="/404"
      />

      <section className="relative overflow-hidden bg-slate-950 px-4 pt-32 pb-24 text-white sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-900/30 via-slate-950 to-slate-950" />
        <div className="relative mx-auto max-w-3xl text-center">
          <div className="mb-8 inline-flex h-24 w-24 items-center justify-center rounded-3xl bg-gradient-to-br from-brand-500 to-brand-700 shadow-2xl shadow-brand-900/30">
            <Search className="h-12 w-12 text-white" />
          </div>
          <p className="text-6xl font-extrabold tracking-tight sm:text-7xl">404</p>
          <h1 className="mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl">
            Page not found
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg text-slate-300">
            The page you are looking for does not exist or may have been moved.
            Everything else is still here.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full bg-brand-600 px-7 py-3.5 text-base font-bold text-white transition hover:bg-brand-700"
            >
              <Home className="h-4 w-4" /> Back to home
            </Link>
            <Link
              to="/features"
              className="inline-flex items-center gap-2 rounded-full border border-slate-600 bg-slate-900/60 px-7 py-3.5 text-base font-bold text-slate-200 transition hover:bg-slate-800"
            >
              <ArrowLeft className="h-4 w-4" /> Explore features
            </Link>
          </div>
          <p className="mt-8 text-sm text-slate-500">
            Still lost? Contact us at{' '}
            <a href={`mailto:${site.supportEmail}`} className="text-brand-400 hover:text-brand-300">
              {site.supportEmail}
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
